// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"47f2e7ee","239":"3a970570","455":"08f60b0b"}[chunkId] + ".chunk.js";
};